import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { RouteComponentProps } from "react-router";
import { IStoreState } from "../../../../reducers/types";

import { fetchTravelWalletDetails } from "../../../travel-wallet/actions/actions";
import { MobileFlightShop } from "./component";
import { fetchPackagesFlightShop } from "../../actions/actions";

import { actions } from "../../actions";
import { getActiveFiltersCount } from "../../reducer";
import { getHotelShopSelectedLodging } from "../../../hotel-shop/reducer";

const mapStateToProps = (state: IStoreState) => {
  return {
    activeFiltersCount: getActiveFiltersCount(state),
    selectedLodging: getHotelShopSelectedLodging(state),
  };
};

export const mapDispatchToProps = {
  fetchTravelWalletDetails: fetchTravelWalletDetails,
  fetchPackagesFlightShop: fetchPackagesFlightShop,
  setSortOption: actions.setSortOption,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type MobileFlightShopConnectorProps = ConnectedProps<typeof connector>;

export interface IMobileFlightShopProps
  extends MobileFlightShopConnectorProps,
    RouteComponentProps {}

export const ConnectedMobileFlightShop = withRouter(
  connector(MobileFlightShop)
);
